import { z } from 'zod';
import { RecurringFeeDefinitionId } from '../types/branded';
import { RecurringFeeBillingCategorySchema } from '../types/enums';

export const RecurringFeeDefinitionSchema = z.object({
  id: RecurringFeeDefinitionId,
  schoolId: z.string().min(1),
  name: z.string().trim().min(1).max(100),
  monthlyAmount: z.number().positive(),
  billingCategory: RecurringFeeBillingCategorySchema,
  billingDay: z.number().int().min(1).max(28),
  startMonth: z.number().int().min(1).max(12),
  endMonth: z.number().int().min(1).max(12),
  eligibleGrades: z.array(z.string().trim().min(1)).nullable().optional(),
  prorateFirstMonth: z.boolean().default(false),
  isActive: z.boolean().default(true),
  deletedAt: z.string().nullable().optional(),
  createdAt: z.string().min(1),
  updatedAt: z.string().min(1),
});
export type RecurringFeeDefinition = z.infer<typeof RecurringFeeDefinitionSchema>;
